/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_NameInputs */

const en_settings_profile_name = /** @type {(inputs: Settings_Profile_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const zh_settings_profile_name = /** @type {(inputs: Settings_Profile_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`姓名`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Settings_Profile_NameInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_profile_name = /** @type {((inputs?: Settings_Profile_NameInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_NameInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_name(inputs)
	return zh_settings_profile_name(inputs)
});
export { settings_profile_name as "settings.profile.name" }